document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector('.product-onyx-gallery')!=null){
   var swipergallery = new Swiper(".product-onyx-gallery", {
      slidesPerView: 1.3,
      slidesPerGroup: 1,
      spaceBetween: 0,
      loop: false,
      watchOverflow: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    // Fix navigation disabling too early
    swipergallery.on('reachEnd', function () {
      swipergallery.navigation.update(); // force re-check
    });
    swipergallery.on('slideChange', function () {
      swipergallery.navigation.update();
    });
  }
});

// PRODUCT VIDEOS -- START
document.addEventListener("click", function (e) {
  const box = e.target.closest(".product_videos_slide-box");
  const closeBtn = e.target.closest(".product_videos_popup_close");
  if (box) {
    document.querySelector(".product_videos_section")?.classList.add("active");
    const id = box.getAttribute("id");
    document.querySelectorAll(".product_videos_popup").forEach(popup => {
      popup.classList.remove("active");
    });
    const targetPopup = document.querySelector(`.product_videos_popup[data-id="${id}"]`);
    if (targetPopup) {
      targetPopup.classList.add("active");
    }
    document.body.classList.add("product_video_play");
  }
  if (closeBtn) {
    document.querySelector(".product_videos_section")?.classList.remove("active");
    document.querySelectorAll(".product_videos_popup").forEach(popup => {
      popup.classList.remove("active");
    });
    document.body.classList.remove("product_video_play");
  }
});

// PRODUCT VIDEOS -- END